import { __awaiter } from "tslib";
import React from 'react';
import { createComponentModel, Disposable, MODELS, useXFlowApp } from '@antv/xflow-core';
import { nodeService } from './utils';
import { isArray } from 'lodash';
export var NsPanelData;
(function (NsPanelData) {
    NsPanelData.id = 'NODE_PANEL_DATA';
})(NsPanelData || (NsPanelData = {}));
/** 节点查找 */
const DefaultsearchService = (nodeList = [], keyword) => __awaiter(void 0, void 0, void 0, function* () {
    const list = nodeList.filter(i => { var _a, _b; return i.isDirectory || ((_a = i.label) === null || _a === void 0 ? void 0 : _a.includes(keyword)) || ((_b = i.name) === null || _b === void 0 ? void 0 : _b.includes(keyword)); });
    return list;
});
export const usePanelData = (props) => {
    const { searchService = DefaultsearchService } = props;
    const registerNode = (props.registerNode
        ? isArray(props.registerNode)
            ? props.registerNode
            : [props.registerNode]
        : []);
    let nodes = [];
    registerNode.forEach(item => {
        nodes = nodes.concat(item.nodes.map(node => (Object.assign(Object.assign({}, node), { parentKey: item.key }))));
    });
    const { modelService } = useXFlowApp();
    /** 使用model */
    const [state, setState, panelModel] = createComponentModel({
        searchList: [],
        nodeList: [],
        defaultExpandAll: false,
        keyword: '',
    });
    /** 注册成为全局状态，方便其他组件联动 */
    React.useEffect(() => {
        if (modelService.findDeferredModel(NsPanelData.id)) {
            return;
        }
        modelService.registerModel({
            id: NsPanelData.id,
            modelFactory: () => panelModel,
            watchChange: (self) => __awaiter(void 0, void 0, void 0, function* () {
                const graphMetaModel = yield MODELS.GRAPH_META.getModel(modelService); //useContext(MODELS.GRAPH_META.id)
                const fetch = () => __awaiter(void 0, void 0, void 0, function* () {
                    const listData = yield nodeService(nodes);
                    return { listData };
                });
                const graphMetaDisposable = graphMetaModel.watch(() => __awaiter(void 0, void 0, void 0, function* () {
                    const data = yield fetch();
                    self.setValue({
                        nodeList: data.listData,
                        defaultExpandAll: false,
                        keyword: '',
                        searchList: [],
                    });
                }));
                return Disposable.create(() => {
                    graphMetaDisposable.dispose();
                });
            }),
        });
        /* eslint-disable-next-line  */
    }, []);
    /** 搜索 */
    const onKeywordChange = React.useCallback((keyword) => __awaiter(void 0, void 0, void 0, function* () {
        if (!searchService) {
            return;
        }
        if (keyword) {
            // @ts-ignore
            const list = yield searchService(state.nodeList, keyword);
            setState(modelState => {
                modelState.keyword = keyword;
                modelState.searchList = list;
            });
        }
        else {
            setState(modelState => {
                modelState.keyword = '';
                modelState.searchList = [];
            });
        }
    }), [searchService, state.nodeList, setState]);
    return {
        state,
        setState,
        onKeywordChange,
    };
};
//# sourceMappingURL=service.js.map